import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const TopSchoolsChart = ({ schools }) => {
    if (!schools || schools.length === 0) return null;

    // Limit to top 10 schools for better visualization
    const topSchools = schools.slice(0, 10);

    const chartData = {
        labels: topSchools.map(school => school.school_name),
        datasets: [
            {
                label: 'SFA Applications',
                data: topSchools.map(school => school.sfa_count),
                backgroundColor: [
                    'rgba(255, 99, 132, 0.8)',
                    'rgba(54, 162, 235, 0.8)',
                    'rgba(255, 206, 86, 0.8)',
                    'rgba(75, 192, 192, 0.8)',
                    'rgba(153, 102, 255, 0.8)',
                    'rgba(255, 159, 64, 0.8)',
                    'rgba(199, 199, 199, 0.8)',
                    'rgba(83, 102, 255, 0.8)',
                    'rgba(255, 99, 132, 0.8)',
                    'rgba(54, 162, 235, 0.8)'
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)',
                    'rgba(199, 199, 199, 1)',
                    'rgba(83, 102, 255, 1)',
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)'
                ],
                borderWidth: 1
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: 'Top Schools by SFA Applications'
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        return `Applications: ${context.parsed.y}`;
                    }
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Number of Applications'
                }
            },
            x: {
                title: {
                    display: true,
                    text: 'Schools'
                },
                ticks: {
                    maxRotation: 45,
                    minRotation: 45
                }
            }
        }
    };

    const totalApplications = topSchools.reduce((sum, school) => sum + school.sfa_count, 0);

    return (
        <div className="card">
            <div className="card-header">
                <h3 className="card-title">
                    <i className="fas fa-university mr-2"></i>
                    Top Schools
                </h3>
                <div className="card-tools">
                    <span className="badge badge-success">
                        Total: {totalApplications} Applications
                    </span>
                </div>
            </div>
            <div className="card-body">
                <div style={{ height: '400px', position: 'relative' }}>
                    <Bar data={chartData} options={options} />
                </div>
                
                {/* School Rankings Table */}
                <div className="table-responsive mt-3">
                    <table className="table table-sm">
                        <thead>
                            <tr>
                                <th>Rank</th>
                                <th>School</th>
                                <th>Applications</th>
                                <th>Percentage</th>
                            </tr>
                        </thead>
                        <tbody>
                            {topSchools.map((school, index) => (
                                <tr key={index}>
                                    <td>
                                        <span className={`badge badge-${index < 3 ? 'primary' : 'secondary'}`}>
                                            #{index + 1}
                                        </span>
                                    </td>
                                    <td>
                                        <strong>{school.school_name}</strong>
                                    </td>
                                    <td>
                                        <span className="badge badge-info">
                                            {school.sfa_count}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="progress" style={{ height: '20px' }}>
                                            <div 
                                                className="progress-bar bg-success" 
                                                style={{ 
                                                    width: `${(school.sfa_count / totalApplications) * 100}%` 
                                                }}
                                            >
                                                {((school.sfa_count / totalApplications) * 100).toFixed(1)}%
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default TopSchoolsChart; 